export default "__VITE_PUBLIC_ASSET__03371f22__"